"use client";

import { useMediaQuery } from "usehooks-ts"
import Link from "next/link";
import { MenuIcon, Phone } from "lucide-react";
import Image from "next/image";
import logo from "../../../public/sel-logo.svg";
import star from "../../../public/etoile.png";
import {
    Sheet,
    SheetContent,
    SheetDescription,
    SheetHeader,
    SheetTitle,
    SheetTrigger,
  } from "@/components/ui/sheet"

const STAR_COUNT = 4;
const tickerMessage = "Le Standard Téléphonique préféré des petites et moyennes entreprises";

const StarsRow = ({ position }: { position: "left" | "right" }) => (
    <div className="flex items-center gap-1">
        {Array.from({ length: STAR_COUNT }).map((_, index) => (
            <Image
                key={`star-${position}-${index}`}
                src={star}
                alt="Étoile"
                width={18}
                height={18}
                className="w-4 h-4 md:w-5 md:h-5"
            />
        ))}
    </div>
);

const MessageWithStars = () => (
    <div className="flex items-center gap-2 overflow-hidden">
        <StarsRow position="left" />
        <p className="text-sm sm:text-base font-semibold text-black whitespace-nowrap truncate">
            {tickerMessage}
        </p>
    </div>
);

const MobileDropdown = () => {

    return (
        <Sheet>
            <SheetTrigger><MenuIcon className="w-4 h-4" /></SheetTrigger>
            <SheetContent>
                <SheetHeader>
                    <SheetTitle className="text-2xl font-bold text-primaryGreen">Menu</SheetTitle>
                    <SheetDescription className="flex flex-col items-start justify-between space-y-6 mt-4">
                        <div className="w-full">
                            <div className="flex items-center gap-2 mb-3">
                                <StarsRow position="left" />
                                <p className="text-base font-semibold text-black">{tickerMessage}</p>
                            </div>
                            <Link href="tel:+33187200200" className="text-base flex items-center justify-center gap-2 hover:text-primaryGreen transition-colors p-4 bg-lightGreen rounded-lg shadow-sm">
                                <Phone className="w-5 h-5 text-primaryGreen" />
                                <p className="font-medium">01 87 200 200</p>
                            </Link>
                        </div>
                    </SheetDescription>
                </SheetHeader>
            </SheetContent>
        </Sheet>
    )
}

const DesktopHeader = () => {
    return (
        <div className="flex justify-between items-center mx-auto max-w-screen-xl p-4 xl:px-0">
            <Link href="/">
                <Image src={logo} alt="Logo" width={500} height={100} className="w-auto h-auto min-h-8" />
            </Link>
            <div className="flex items-center gap-4">
                <MessageWithStars />
                <Link href="tel:+33187200200" className="text-base flex items-center gap-2 hover:text-primaryGreen transition-colors">
                    <Phone className="w-5 h-5 text-primaryGreen" />
                    <p className="font-medium">01 87 200 200</p>
                </Link>
            </div>
        </div>
    )
}

const MobileHeader = () => {
    return (
        <div className="flex justify-between items-center mx-auto max-w-screen-xl p-4 lg:px-0">
            <Link href="/">
                <Image src={logo} alt="Logo" width={500} height={100} className="w-auto h-auto min-h-6" />
            </Link>
            <MobileDropdown />
        </div>
    )
}

export const Header = () => {
    // Mobile/Tablet jusqu'à 1024px (iPhone/Android récents + iPad standard)
    const isMobile = useMediaQuery("(max-width: 1024px)");
    
    return (
        <div className="w-full shadow-lg z-10 bg-white">
            {isMobile ? <MobileHeader /> : <DesktopHeader />}
        </div>
    )
}